import { render, staticRenderFns } from "./phoneApproval.vue?vue&type=template&id=cd13276a&scoped=true&"
import script from "./phoneApproval.vue?vue&type=script&lang=js&"
export * from "./phoneApproval.vue?vue&type=script&lang=js&"
import style0 from "./phoneApproval.vue?vue&type=style&index=0&id=cd13276a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd13276a",
  null
  
)

component.options.__file = "phoneApproval.vue"
export default component.exports